import React from 'react';
import styled from 'styled-components';

const ShortButtonWrapper = styled.button`
  box-sizing: border-box;
  height: auto;
  width: auto;
  border: 1px solid #0a8b8f;
  border-radius: 3px;
  background-color: #ffffff;
  color: #0a8b8f;
  cursor: ${props => (props.disabled ? 'wait' : 'pointer')};
  padding: 4px;
  &:hover {
    box-shadow: 0 4px 8px 0 rgba(94, 48, 165, 0.37);
  }
`;

class ShortButton extends React.Component {
  render() {
    return <ShortButtonWrapper {...this.props}>{this.props.children}</ShortButtonWrapper>;
  }
}

export default ShortButton;
